import React from 'react';
import classNames from 'classnames';
import * as Validation from '../utils/validation';
import { Form as AForm, InputGroup, TextField, Text, Modal } from '../../components';
import { Button } from '@kmx/legos-react-button';
import AppForm from '../constants/app-forms';


class ThirdPartyForm extends React.Component {
  constructor(props) {
    super(props);
    this.formType = AppForm.ThirdParty;
    this.state = {
      formFields: {     
        thirdPartyName:'',
		    thirdPartyEmail:'',
        thirdPartyFile:null
      },
      invalidFields: []
      ,fileExtensionValid: true //don't start with a nag message
    };

    this.timer = null;
    this.formRef = React.createRef();

    this.onSubmit = this.onSubmit.bind(this);
    this.onValidateHandler = this.onValidateHandler.bind(this);
    this.updateFormFields = this.updateFormFields.bind(this);
    this.updateFile = this.updateFile.bind(this);
    this.scrollTop = this.scrollTop.bind(this);
  }
 
  scrollTop() {
    window && window.scrollTo(0, 0);
  }

  onValidateHandler(invalidFields) {
    this.setState({ invalidFields });
  }
  
  updateFormFields(Validation, e) {
    this.setState({
      formFields: {
        ...this.state.formFields,
        [e.target.name]: Validation,
      },
    });
  }

  updateFile() {
    let file = null;
    let fileExtension = '';
    const fileInput = document.getElementById('authorizationDoc');

    if(fileInput.files && fileInput.files.length > 0) {
      file = fileInput.files[0];
      try {
        fileExtension = fileInput.value.split(/\./g).pop().toLowerCase();
      // eslint-disable-next-line no-empty
      } catch {

      }
    }
    const extensionValid = fileExtension === 'pdf';
    this.setState({ formFields: { ...this.state.formFields, thirdPartyFile: file} , fileExtensionValid: extensionValid });
  }

  onSubmit() {
	this.props.handleNextStep(this.formType, this.state.formFields);
}
  

  

  
  render() {
    const { invalidFields, showInitialForm } = this.state;
    const { formFields } = this.state;
    const { thirdPartyName, thirdPartyEmail } = formFields;
    const submitDisabled = invalidFields.length > 0 || this.state.formFields.thirdPartyFile === null || !this.state.fileExtensionValid

    return (
      <div className='third-party-form'>
        <AForm onValidate={this.onValidateHandler} ref={this.formRef}>
          <div className={classNames([{ fade: !showInitialForm }])}>
            <Text.Display3>Third Party Authorization</Text.Display3>
            <Text.Body1 className='m-b-l'>
            Please attach documentation demonstrating the authorization to submit this request.  A separate request must be submitted for each data privacy right you are requesting. 
            All communication about the request will be sent to the email address you provide below.
            </Text.Body1>

            <div ref={(node) => (this.node = node)}>
              <InputGroup>
                <TextField
                  className='m-t-0 m-b-0 fs-mask'
                  errorText='Name of Authorized Third Party'
                  onChange={this.updateFormFields}
                  label='Name of Authorized Third Party'
                  name='thirdPartyName'
                  required
                  value={thirdPartyName}
                />
              </InputGroup>
            </div>
            <InputGroup>
              <TextField
                className='m-t-0 m-b-0 fs-mask'
                onChange={this.updateFormFields}
                label='Email Address for Authorized Third Party'
                name='thirdPartyEmail'
                id='thirdPartyEmail'
                value={thirdPartyEmail}
                required
                validation={Validation.isValidEmail}
              />
            </InputGroup>

            <InputGroup>
			        <div class="third-party-upload kmx-typography--body-1 m-b-l fs-mask">
                <p>Please provide an authorization document.</p>
			          <input type="file" id="authorizationDoc" onChange={this.updateFile} accept=".pdf" />
                {!this.state.fileExtensionValid && (
                <div class="kmx-text-field__error-text kmx-text-field__error-text--active">Please choose a PDF file.</div>
                )}
              </div>
            </InputGroup>
            

           

            <Button className='kmx-button--full m-t-l' disabled={submitDisabled} level='primary' type='button' onClick={this.onSubmit}>
              Submit
            </Button>
          </div>
        </AForm>
      </div>
    );
  }
}

export default ThirdPartyForm;
